var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.isDesktop)?_c('PcComponent'):_c('H5Component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }